import httpClient from "../http/http.client";

export const getHome = async () => {
  const { data, errors } = await httpClient.get({
    url: "/home?populate[Intro][populate]=*&populate[Projects][populate]=*&populate[AboutUs][populate][points][populate]=Image&populate[AboutUs][populate]=Image&populate[Companies][populate]=*&populate[WhyUs][populate][Card][populate]=Image&populate[Testimonials][populate][Card][populate]=ProfileImage&populate[Capabilities][populate][Card][populate]=Image&populate[Industries][populate][Card][populate]=Image&populate[WorkProcess][populate]=*&populate[Team][populate][Card][populate]=ProfileImage",
  });
  return { data, errors };
};
export const sendEmail = async (body) => {
  const { data, errors } = await httpClient.get({
    url: "https://ouforibpsktwl62nkl2shklghq0mfqra.lambda-url.ap-south-1.on.aws/",
    body,
  });
  return { data, errors };
};

export const getPrivacyPolicy = async () => {
  const { data, errors } = await httpClient.get({
    url: "/private-policy?populate=*",
  });
  return { data, errors };
};

export const getTermsAndConditions = async () => {
  const { data, errors } = await httpClient.get({
    url: "/terms-and-condition?populate=*",
  });
  return { data, errors };
};
export const getIndustries = async () => {
  const { data, errors } = await httpClient.get({
    url: "/industry?populate[Industry][populate][0]=Image&populate[Industry][populate][1]=ContentSection",
  });
  return { data, errors };
};
